// Default query for countries actions
export const COUNTRY_VAT_DETAIL = `
    code
    vat
    pct
    currency
    vat_acronym
`;